import get_standardised_date from "./get_standardised_date";

export default function getDayDiff(processed_until) {
    let today = new Date();
    let processed_until_date = new Date(get_standardised_date(processed_until));
    return processed_until_date.getDate() - today.getDate();
}
